module.exports = __webpack_public_path__ + "img/Vegetable-Lasagna-3.13e31b28.jpg";